import $ from 'jquery';

const initSearchNavigation = () => {
  const $searchResultsContainer = $('#container-search-results');
  const $nextLinksContainer = $searchResultsContainer.find('.search-next-links-container');
  const $nextLink = $searchResultsContainer.find('a.search-next-link');
  const $nextBusyLink = $searchResultsContainer.find('a.search-next-link-busy');

  // Set idle state
  $nextBusyLink.hide();
  $nextLink.show();

  $nextLink.click((e) => {
    // Prevent the browser from navigating to the href
    e.preventDefault();
    $nextLink.unbind();

    // Set busy state
    $nextBusyLink.show();
    $nextLink.hide();

    $.get(e.currentTarget.href, (html) => {
      // Remove existing buttons from DOM
      $nextLinksContainer.remove();
      // Add new html to DOM
      $searchResultsContainer.append(html);
    }).always(initSearchNavigation); // Re-init search on success (for new HTML) and error (for retry)
  });
};

export { initSearchNavigation };
